import { decryptData, encryptData } from "config/config";
import { instance as axios } from "config/axiosInstance";
import { isLoggedIn } from "utils";

export const getSubjects = async (data) => {
  return decryptData(
    await axios.get(
      `/subject?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};

export const addSubject = async (data) => {
  return decryptData(
    await axios.post(`/subject-create`, {
      reqData: encryptData({
        ...data,
        access_token: isLoggedIn(),
      }),
    })
  );
};

export const updateSubject = async (data) => {
  return decryptData(
    await axios.post(`/subject-edit`, {
      reqData: encryptData({
        ...data,
        access_token: isLoggedIn(),
      }),
    })
  );
};

export const updateSubjectStatus = async (data) => {
  return decryptData(
    await axios.get(
      `/subject-status?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};

export const deleteSubject = async (data) => {
  return decryptData(
    await axios.get(
      `/subject-delete?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};
